module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background-color": "white"
    },
    attrs: {
      "id": "merchandises"
    }
  }, [_c('div', {
    staticClass: "content",
    staticStyle: {
      "margin-bottom": "2rem",
      "background-color": "white"
    }
  }, [_c('div', {
    staticClass: "page-detail"
  }, [_c('div', {
    staticClass: "content-block"
  }, [_vm._m(0), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "list-block",
    staticStyle: {
      "margin-top": "0rem"
    },
    attrs: {
      "id": "tab-detail"
    }
  }, [(_vm.productName !== '') ? _c('div', [_c('span', {
    staticStyle: {
      "color": "#00469A"
    }
  }, [_vm._v("商品名称")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "WORD-BREAK": "break-all",
      "WORD-WRAP": "break-word"
    }
  }, [_vm._v(_vm._s(_vm.productName))]), _vm._v(" "), _vm._m(1)]) : _vm._e(), _vm._v(" "), _vm._l((_vm.attributeList), function(merchandise) {
    return _c('div', {
      staticStyle: {
        "margin-bottom": "0.3rem",
        "margin-top": "1.2rem",
        "margin-left": "0.2rem",
        "margin-right": "0.2rem"
      }
    }, [(merchandise.valueText && merchandise.valueText !== '-1') ? _c('div', [(merchandise.valueText.length > 45) ? _c('div', [_c('span', {
      staticStyle: {
        "color": "#00469A"
      }
    }, [_vm._v(_vm._s(merchandise.label))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "float": "right",
        "width": "9rem"
      }
    }, [_vm._v(_vm._s(merchandise.valueText))]), _vm._v(" "), _vm._m(2, true)]) : _vm._e(), _vm._v(" "), (merchandise.valueText.length > 30 && merchandise.valueText.length <= 45) ? _c('div', [_c('span', {
      staticStyle: {
        "color": "#00469A"
      }
    }, [_vm._v(_vm._s(merchandise.label))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "float": "right",
        "width": "9rem"
      }
    }, [_vm._v(_vm._s(merchandise.valueText))]), _vm._v(" "), _vm._m(3, true)]) : _vm._e(), _vm._v(" "), (merchandise.valueText.length > 14 && merchandise.valueText.length <= 30) ? _c('div', [_c('span', {
      staticStyle: {
        "color": "#00469A"
      }
    }, [_vm._v(_vm._s(merchandise.label))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "float": "right",
        "width": "9rem"
      }
    }, [_vm._v(_vm._s(merchandise.valueText))]), _vm._v(" "), _vm._m(4, true)]) : _vm._e(), _vm._v(" "), (merchandise.valueText.length <= 14) ? _c('div', [_c('span', {
      staticStyle: {
        "color": "#00469A"
      }
    }, [_vm._v(_vm._s(merchandise.label))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "float": "right"
      }
    }, [_vm._v(_vm._s(merchandise.valueText))]), _vm._v(" "), _vm._m(5, true)]) : _vm._e()]) : _vm._e()])
  }), _vm._v(" "), _c('div', [_c('span', {
    staticStyle: {
      "color": "#00469A"
    }
  }, [_vm._v("周期")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v(_vm._s(_vm.workdays))]), _vm._v(" "), _vm._m(6)]), _vm._v(" "), (_vm.templateSource !== '') ? _c('div', [_c('span', {
    staticStyle: {
      "color": "#00469A"
    }
  }, [_vm._v("模版来源")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v(_vm._s(_vm.templateSource))]), _vm._v(" "), _vm._m(7)]) : _vm._e()], 2)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-bottom": "2rem",
      "margin-top": "0.6rem"
    }
  }, [_c('div', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "center",
      "color": "#00469A",
      "font-size": "1.2rem"
    }
  }, [_vm._v("定制商品详情")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-top": "1rem"
    }
  }, [_c('hr', {
    staticStyle: {
      "height": "0.06rem",
      "border": "0.06rem",
      "background-color": "#B4B4B4"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-top": "3.8rem"
    }
  }, [_c('hr', {
    staticStyle: {
      "height": "0.06rem",
      "border": "0.06rem",
      "background-color": "#B4B4B4"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-top": "2.5rem"
    }
  }, [_c('hr', {
    staticStyle: {
      "height": "0.06rem",
      "border": "0.06rem",
      "background-color": "#B4B4B4"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-top": "2.5rem"
    }
  }, [_c('hr', {
    staticStyle: {
      "height": "0.06rem",
      "border": "0.06rem",
      "background-color": "#B4B4B4"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-top": "1rem"
    }
  }, [_c('hr', {
    staticStyle: {
      "height": "0.06rem",
      "border": "0.06rem",
      "background-color": "#B4B4B4"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-top": "1rem"
    }
  }, [_c('hr', {
    staticStyle: {
      "height": "0.06rem",
      "border": "0.06rem",
      "background-color": "#B4B4B4"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-top": "1rem"
    }
  }, [_c('hr', {
    staticStyle: {
      "height": "0.06rem",
      "border": "0.06rem",
      "background-color": "#B4B4B4"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ff5c8ec6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./script/loaders/emktVueLoader.js!./src/views/Cust/Detail/CustDetail.vue
// module id = 1746
// module chunks = 8